export const productionByEtpChartConfig = (data, colors, legendLabels) => {
    return {
        appendPadding: 50,
        data,
        angleField: 'value',
        colorField: 'type',
        radius: 1,
        color: colors,
        innerRadius: 0.75,
        legend: {
            layout: 'horizontal',
            position: 'bottom',
            itemWidth: 150,
            items: legendLabels,
            maxHeight: 0
        },
        label: false,
        interactions: [
            {
                type: 'element-selected'
            },
            {
                type: 'element-active'
            }
        ],
        statistic: {
            title: false,
            content: {
                style: {
                    whiteSpace: 'wrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontFamily: 'Din Condensed',
                    color: '#030303',
                    fontSize: '28px'
                },
                content: 'Production par ETP ventilées par statut'
            }
        }
    };
}